'use client';

import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from '../hooks/useAuth';
import { SystemSettingsProvider } from '../contexts/SystemSettingsContext';
import Navigation from './Navigation';
import ToastContainer from './ToastContainer';
import ClientToastContainer from './ClientToastContainer';
import WhatsAppPopup from './WhatsAppPopup';
import DynamicFavicon from './DynamicFavicon';
import FontLoader from './FontLoader';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <SystemSettingsProvider>
        <DynamicFavicon />
        <FontLoader />
        <ToastContainer />
        <NavigationWrapper />
        <div className="pt-20">
          <main className="mt-6">{children}</main>
        </div>
        <ClientToastContainer />
        <WhatsAppPopup />
      </SystemSettingsProvider>
    </AuthProvider>
  );
}

function NavigationWrapper() {
  const { user, refreshUser, logout } = useAuth();
  
  const handleUserUpdate = (userData: any) => {
    refreshUser(userData);
  };
  
  return <Navigation user={user} setUser={handleUserUpdate} />;
}
